module.exports = __webpack_public_path__ + "img/cttbaleares-icon.fb3f862e.png";